import { Injectable } from '@angular/core';
import { HttpWrapper } from '../../../shared/services';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';

export interface SofDefinitionEntry {
  sofType: string;
  phase: string;
  events: string;
  canonical: string;
}

export interface SofTemplateDefinitionEntry {
  code: string;
  isRequired: boolean;
}

export interface SofTemplate {
  id: string;
  sofType: string;
  entries: SofTemplateDefinitionEntry[];
}

@Injectable({providedIn : 'root'})
export class SofTemplateService {

  constructor(private _httpWrapper: HttpWrapper,
              private _lookupService: LookupServiceSpa) { }

  add(sofTemplateEntry: SofDefinitionEntry) {
    return this._httpWrapper.post<string, SofDefinitionEntry>('vessels/sofDefinitionEntry', sofTemplateEntry);
  }

  async getAllSofItems(): Promise<[SofTemplateDefinitionEntry, string][]> {
    const items = await this._lookupService.getLookupItems({categoryName: 'voyage_sof_all'});
    return items.items.map(j => [
      {
        code: j.values[0],
        isRequired: false
      },
      j.values[2]
    ]);
  }

  async getSofTemplate(id: string): Promise<[SofTemplateDefinitionEntry, string][]> {

    const all = await this._lookupService.getLookupItems({ categoryName: 'voyage_sof_all'});
    const temp = await this._lookupService.getLookupItems({categoryName: id});

    const allSofItems = all.items.map(i => i.values);
    const sofTemplateDefinitionItems = temp.items.map(i => i.values);

    return sofTemplateDefinitionItems.map(i => {
      const foundItem = this.findSofEntryByCode(allSofItems, i[0]);
      return [{
        code: foundItem[0],
        isRequired: i[1] === 'True' || i[1] === 'true'
      }, foundItem[2]];
    });
  }

  updateTemplate(sofTemplate: SofTemplate) {
    return this._httpWrapper.put<SofTemplate, SofTemplate>('vessels/sofTemplate', sofTemplate);
  }

  addTemplate(sofTemplate: SofTemplate) {
    return this._httpWrapper.post<SofTemplate, SofTemplate>('vessels/sofTemplate', sofTemplate);
  }

  private findSofEntryByCode(allItems: string[][], code: string) {
    const foundSof = allItems.find(s => s[0] === code);
    if (!foundSof) {
      console.error(`Could not find Sof entry for code ${code}`);
      return  '';
    }
    return foundSof;
  }
}
